import React, { Component } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import TextField from "@mui/material/TextField";
import { Calendar } from "primereact/calendar";
import { DamageRptActions } from "../../actions/DamageRptActions";
import { connect } from "react-redux";
import tableRequest from "../../models/tableRequest.js";
import { Toast } from "primereact/toast";
import { CSVLink } from "react-csv";

class DamageRpt extends Component {
  constructor(props) {
    super(props);
    this.csvLink = React.createRef();
    this.tblResponse = new tableRequest();
    this.tblResponse.PageSize = 5;
    this.onPage = this.onPage.bind(this);
    this.onSort = this.onSort.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.FilterData = this.FilterData.bind(this);
    this.searchFilter = this.searchFilter.bind(this);
    this.Export = this.Export.bind(this);
    this.state = {
      loading: true,
      FromDate: new Date(),
      ToDate: new Date(),
      first: 0,
      rows: 5,
      totalRecords: 0,
      globalFilter: null,
      sortField: null,
      sortOrder: 1, // 1 for ASC, -1 for DESC
      Download: false,
      headers: [
        { label: "From No", key: "FromNo" },
        { label: "To No", key: "ToNo" },
        { label: "Qty", key: "Qty" },
        { label: "Damaged On", key: "CreatedDate" },
      ],
    };
  }

  componentDidMount() {
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() - 7);

    this.setState(
      {
        FromDate: date,
        ToDate: new Date(),
        loading: true,
      },
      () => {
        this.tblResponse.FromDate = this.formatDate(date);
        this.tblResponse.ToDate = this.formatDate(new Date());
        this.tblResponse.First = 1;
        this.tblResponse.PageSize = this.state.rows;
        this.tblResponse.IsActive = true;
        this.props.fetchApi(this.tblResponse);
        this.props.exportingData(this.tblResponse);
      }
    );
  }

  componentDidUpdate(prevProps) {
    if (prevProps.DamageRptList !== this.props.DamageRptList) {
      if (this.props.DamageRptList && this.props.DamageRptList.length > 0) {
        this.setState({
          totalRecords: parseInt(this.props.DamageRptList[0]?.TotalRows || 0),
          loading: false,
        });
      } else {
        this.setState({ loading: false });
      }
    }
    if (
      this.state.Download &&
      prevProps.List === this.props.List &&
      this.props.List?.length > 0
    ) {
      setTimeout(() => {
        if (this.csvLink.current) {
          this.csvLink.current.link.click();
        }
        this.setState({ Download: false });
      }, 500);
    } else if (this.state.Download && (!this.props.List || this.props.List.length === 0)) {
      this.toast.show({
        severity: "warn",
        summary: "No Data",
        detail: "No data available to export.",
        life: 3000,
      });
      this.setState({ Download: false });
    }
  }

  formatDate(date) {
    if (!date || !(date instanceof Date) || isNaN(date)) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}/${month}/${day}`;
  }

  FilterData() {
    this.setState({ loading: true, first: 0 }, () => {
      this.tblResponse.FromDate = this.formatDate(this.state.FromDate);
      this.tblResponse.ToDate = this.formatDate(this.state.ToDate);
      this.tblResponse.First = 1;
      this.tblResponse.PageSize = this.state.rows;
      this.tblResponse.IsActive = true;
      this.props.fetchApi(this.tblResponse);
      this.props.exportingData(this.tblResponse);
    });
  }

  handleChange(event) {
    const { name, value } = event.target;
    switch (name) {
      case "FromDate":
        if (!value || !(value instanceof Date) || isNaN(value)) {
          this.toast.show({
            severity: "error",
            summary: "Error Message",
            detail: "Please select a valid from date.",
            life: 3000,
          });
          return;
        } else if (this.state.ToDate instanceof Date && !isNaN(this.state.ToDate)) {
          const startDate = value;
          const endDate = this.state.ToDate;
          if (Date.parse(startDate) > Date.parse(endDate)) {
            this.toast.show({
              severity: "error",
              summary: "Error Message",
              detail: "From date must be less than or equal to to date.",
              life: 3000,
            });
            return;
          }
        }
        break;
      case "ToDate":
        if (!value || !(value instanceof Date) || isNaN(value)) {
          this.toast.show({
            severity: "error",
            summary: "Error Message",
            detail: "Please select a valid to date.",
            life: 3000,
          });
          return;
        } else if (this.state.FromDate instanceof Date && !isNaN(this.state.FromDate)) {
          const startDate = this.state.FromDate;
          const endDate = value;
          if (Date.parse(startDate) > Date.parse(endDate)) {
            this.toast.show({
              severity: "error",
              summary: "Error Message",
              detail: "To date must be greater than or equal to from date.",
              life: 3000,
            });
            return;
          }
        }
        break;
      default:
        break;
    }
    this.setState({ [name]: value });
  }

  getLazyLoadingValues(event) {
    this.tblResponse.PageSize = event.rows;
    this.tblResponse.First = event.first + 1;
    this.tblResponse.IsActive = true;
    this.tblResponse.SearchValue = event.globalFilter || "";
    this.tblResponse.SortColumn = this.state.sortField || "";
    this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "ASC" : "DESC";
    this.tblResponse.FromDate = this.formatDate(this.state.FromDate);
    this.tblResponse.ToDate = this.formatDate(this.state.ToDate);
  }

  onPage(event) {
    this.setState({ rows: event.rows, first: event.first, loading: true }, () => {
      this.getLazyLoadingValues(event);
      this.props.fetchApi(this.tblResponse);
      this.props.exportingData(this.tblResponse);
    });
  }

  Export() {
    this.setState({ Download: true });
    if (!this.props.List || this.props.List.length === 0) {
      this.toast.show({
        severity: "warn",
        summary: "No Data",
        detail: "No data available to export.",
        life: 3000,
      });
      this.setState({ Download: false });
    }
    else{
       this.tblResponse.PageSize = -1;
    this.tblResponse.First =1;
    this.tblResponse.IsActive = true;
    this.tblResponse.SearchValue = this.state.globalFilter || "";
    this.tblResponse.SortColumn = this.state.sortField || "";
    this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "ASC" : "DESC";
    this.tblResponse.FromDate = this.formatDate(this.state.FromDate);
    this.tblResponse.ToDate = this.formatDate(this.state.ToDate);
    this.props.exportingData(this.tblResponse);
    }
  }

  searchFilter(e) {
    this.setState({ globalFilter: e.target.value, first: 0, loading: true }, () => {
      this.tblResponse.SearchValue = e.target.value || "";
      this.tblResponse.First = 1;
      this.tblResponse.FromDate = this.formatDate(this.state.FromDate);
      this.tblResponse.ToDate = this.formatDate(this.state.ToDate);
      this.tblResponse.PageSize = this.state.rows;
      this.tblResponse.IsActive = true;
      this.props.fetchApi(this.tblResponse);
      this.props.exportingData(this.tblResponse);
    });
  }

  onSort(event) {
    const sortField = event.multiSortMeta?.[0]?.field || "";
    const sortOrder = this.state.sortOrder === 1 ? -1 : 1;
    this.setState({ sortField, sortOrder, first: 0, loading: true }, () => {
      this.tblResponse.SortColumn = sortField;
      this.tblResponse.SortOrder = sortOrder === 1 ? "ASC" : "DESC";
      this.tblResponse.First = 1;
      this.tblResponse.FromDate = this.formatDate(this.state.FromDate);
      this.tblResponse.ToDate = this.formatDate(this.state.ToDate);
      this.tblResponse.PageSize = this.state.rows;
      this.tblResponse.IsActive = true;
      this.props.fetchApi(this.tblResponse);
      this.props.exportingData(this.tblResponse);
    });
  }

  render() {
    return (
      <div className="datatable-filter-demo">
        <Toast ref={(el) => (this.toast = el)} />
        <div className="row mb-3">
          <div className="col-md-2 report">
            <h4>Damage Report</h4>
          </div>
          <div className="col-md-10">
            <div className="row text-right">
              <div className="col-md-3">
                <Calendar
                  placeholder="From Date"
                  name="FromDate"
                  showIcon="true"
                  value={this.state.FromDate}
                  onChange={this.handleChange}
                />
              </div>
              <div className="col-md-3">
                <Calendar
                  placeholder="To Date"
                  name="ToDate"
                  showIcon="true"
                  value={this.state.ToDate}
                  onChange={this.handleChange}
                />
              </div>
              <div className="col-md-3 text-center">
                <button
                  type="button"
                  onClick={this.FilterData}
                  className="btn btn-primary p-2 pl-2 pr-2 buttone"
                >
                  Submit
                </button>{" "}
                <CSVLink
                  data={this.props.List || []}
                  headers={this.state.headers}
                  filename={"Damage_Report.csv"}
                  target="_blank"
                  ref={this.csvLink}
                />
                <button
                  onClick={this.Export}
                  className="btn btn-success p-2 pr-2 pl-2 buttone"
                >
                  Export
                </button>
              </div>
              <div className="col-md-3">
                <TextField
                  id="standard-basic"
                  size="small"
                  variant="outlined"
                  className="fullwidth"
                  label="Search"
                  onInput={this.searchFilter}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="card">
          <DataTable
            value={this.props.DamageRptList || []}
            scrollable
            responsive={true}
            globalFilter={this.state.globalFilter}
            emptyMessage="No Data found."
            sortMode="multiple"
            paginator={true}
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={this.state.rows}
            style={{ width: "100%" }}
            rowsPerPageOptions={[5, 10, 20]}
            totalRecords={this.state.totalRecords}
            lazy={true}
            first={this.state.first}
            onPage={this.onPage}
            onSort={this.onSort}
            loading={this.state.loading}
            ref={(el) => (this.dt = el)}
            multiSortMeta={this.state.sortField ? [{ field: this.state.sortField, order: this.state.sortOrder }] : []}
          >
            <Column
              style={{ width: "25%" }}
              field="FromNo"
              header="From No"
              sortable
            />
            <Column
              style={{ width: "25%" }}
              field="ToNo"
              header="To No"
              sortable
            />
            <Column
              style={{ width: "25%" }}
              field="Qty"
              header="Qty"
              sortable
            />
            <Column
              style={{ width: "25%" }}
              field="CreatedDate"
              header="Damaged On"
              sortable
            />
          </DataTable>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    DamageRptList: state.DamageRpt.items || [],
    List: state.DamageRpt.exportitems || [],
    loading: state.DamageRpt.loding || false,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchApi: (obj) => dispatch(DamageRptActions.getAll(obj)),
    loadingData: (isLoding) => dispatch(DamageRptActions.loadingData(isLoding)),
    exportingData: (obj) => dispatch(DamageRptActions.exportData(obj)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DamageRpt);